import { ChangeDetectionStrategy, Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ICONS } from '@constants';
import { CardSelectOption } from '@interfaces';

@Component({
  selector: 'app-card-select',
  templateUrl: './card-select.component.html',
  styleUrls: ['./card-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CardSelectComponent),
      multi: true,
    },
  ],
})
export class CardSelectComponent implements ControlValueAccessor {
  @Input() options: CardSelectOption[] = [];
  @Input() columns = 2; // default columns

  value: number | string | null = null;
  disabled = false;

  private onChange: (v: number | string | null) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: number | string | null): void {
    this.value = value ?? null;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  select(option: CardSelectOption) {
    if (this.disabled) {
      return;
    }

    if (this.value === option.value) {
      this.value = null;
      this.onChange(null);
      this.onTouched();
      return;
    }

    this.value = option.value;
    this.onChange(this.value);
    this.onTouched();
  }

  isSelected(option: CardSelectOption) {
    return this.value === option.value;
  }

  getIcon(name: string): string {
    return ICONS['report_type'][name] || 'warning';
  }
}
